import type { BigFraction } from "@aprao/common/src/math/BigFraction.js";
import { wrapFraction } from "@aprao/common/src/math/wrapFraction.js";
import type { CountableNumber } from "@aprao/common/src/shapes/common.js";
import { makeAutoObservable } from "mobx";

import type { ShapeOtherIncomeItem } from "../../shapes/ShapeRevenueGroup.js";

export class OtherIncomeItemFacade {
  constructor(readonly $model: ShapeOtherIncomeItem) {
    makeAutoObservable(this);
  }

  get description() {
    return this.$model.description;
  }

  get quantity() {
    return this.$model.quantity;
  }

  get value() {
    return wrapFraction(this.$model.value);
  }

  /**
   * The total combined value for all the items in this kind.
   */
  get aggregateValue() {
    return this.value?.mul(this.quantity) ?? null;
  }

  set description(description: string) {
    this.$model.description = description;
  }

  set quantity(quantity: CountableNumber) {
    this.$model.quantity = quantity;
  }

  set value(value: BigFraction | null) {
    this.$model.value = value?.toFraction() ?? null;
  }
}
